import React, {useState} from "react";

const CantidadPlan = (props) => {
    const {cantidad, pf, ps, fn} = props;
    const [valor, setValor] = useState(cantidad);

    const handleChange = (e) => {
        setValor(e.target.value === ''?0:e.target.value);
        fn(e.target.value, pf, ps);
    }

    return (
        <input className={valor > 0?"mt-1 text-xs text-right appearance-none block w-20 bg-orange-200 text-gray-700 border border-orange-200 rounded py-3 px-2 leading-tight focus:outline-none focus:bg-white focus:border-gray-500":
                                    "text-xs text-right appearance-none block w-20 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-2 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"}
               type="number"
               step="any"
               name="cantidad"
               value={valor}
               onChange={handleChange}/>
    )
}

export default CantidadPlan;
